var _path, _path2, _circle, _circle2, _circle3, _circle4, _circle5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAlogrithm = function SvgAlogrithm(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#001D52",
    d: "M3.5 2 9 7M3.5 2 2 8.5M3.5 2H14M9 7l5-5M9 7 2 8.5M9 7l-2 7m2-7 5 5m0-10v10M2 8.5 7 14m0 0 7-2"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 3.5,
    cy: 2.5,
    r: 1.5,
    fill: "#001D52"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 13.5,
    cy: 2.5,
    r: 1.5,
    fill: "#001D52"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 13.5,
    cy: 11.5,
    r: 1.5,
    fill: "#001D52"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 13.5,
    r: 1.5,
    fill: "#001D52"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.5,
    cy: 8.5,
    r: 1.5,
    fill: "#001D52"
  })));
};
export default SvgAlogrithm;